import { render, staticRenderFns } from "./modal-sendnewversion.vue?vue&type=template&id=6076c66e&scoped=true&"
import script from "./modal-sendnewversion.vue?vue&type=script&lang=js&"
export * from "./modal-sendnewversion.vue?vue&type=script&lang=js&"
import style0 from "./modal-sendnewversion.vue?vue&type=style&index=0&id=6076c66e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6076c66e",
  null
  
)

export default component.exports